<template>
    <div id="fnproducts_packs_component"
         class="fnproducts-packs-component">
        <div class="codes-list-outer table-responsive">
            <div class="data-loader" v-if="loader"></div>
            <div class="table-outer">
                <table class="table-style1">
                    <thead>
                        <tr>
                            <th><p>Date</p></th>
                            <th><p>Bonus</p></th>
                            <th><p>Amount to FutureNet Product Packs</p></th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(single, index) in rows"
                        :key="index">
                        <td><p>{{ datetime.utcToLocal(single.date) }}</p></td>
                        <td><p>{{ single.source.replace('-', ' ').toUpperCase() }}</p></td>
                        <td><p>FND {{ money.format(single.amount, 'fnd') }}</p></td>
                    </tr>
                    </tbody>
                </table>
                <p v-if="rows.length == 0" style="margin-top: 25px;">No results.</p>
            </div>
        </div>
        <pagination-component :current-page="currentPage"
                              :items="items"
                              :loader="loader"
                              :number-of-pages="numberOfPages"
                              :set-items="setItems"
                              :set-page="setPage"></pagination-component>
    </div>
</template>

<script>
    export default {
        dependencies: ['datetime', 'money', 'packet'],
        data () {
            return {
                loader: false,
                items: 25
            }
        },
        computed: {
            rows () {
                return this.$store.getters.fnproductPacks;
            },
            currentPage () {
                return this.$store.getters.fnproductPacksSettings.currentPage;
            },
            maxPerPage () {
                return this.$store.getters.fnproductPacksSettings.maxPerPage;
            },
            numberOfPages () {
                return this.$store.getters.fnproductPacksSettings.numberOfPages;
            }
        },
        methods: {
            /**
             * Get data with transactions
             */
            getData () {
                this.loader = true;

                let settings = this.$store.getters.fnproductPacksSettings;

                this.$store.dispatch('loadFnproductPacks', {
                    params: settings
                }).then(() => {
                    this.loader = false;
                });
            },

            /**
             * Set number of items per page
             */
            setItems (items) {
                this.items = items;
                this.$store.dispatch('fnproductPacksSetItems', items).then(() => {
                    this.getData();
                });
            },

            /**
             * Set current page
             * @param page
             */
            setPage (page) {
                this.$store.dispatch('fnproductPacksSetPage', page).then(() => {
                    this.getData();
                });
            }
        },
        beforeMount () {
            let settings = this.$store.getters.fnproductPacksSettings;

            this.$store.dispatch('loadFnproductPacks', {
                params: settings
            }).then(() => {
                this.items = settings.maxPerPage;
            });
        }
    }
</script>

<style lang="scss" scoped>
    .fnproducts-packs-component {
        position: relative;
        margin-bottom: 34px;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/fnproductpacks/Table.vue